import { buildUrlString } from '@!/Util'

export function storeBookColophonUrl(content_id, isSample) {
  const path = `/store/books/${content_id}/colophon`
  return buildUrlString(path, { is_sample: isSample })
}
